// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"Cart_with-ellipsis---sb","withEllipsis":"Cart_with-ellipsis---sb","cart":"Cart_cart---sb","rtl":"Cart_rtl---sb","coupon":"Cart_coupon---sb","mobile-view":"Cart_mobile-view---sb","mobileView":"Cart_mobile-view---sb","title":"Cart_title---sb","code":"Cart_code---sb","unvalid":"Cart_unvalid---sb","booking-rating":"Cart_booking-rating---sb","bookingRating":"Cart_booking-rating---sb","cancelation-policy":"Cart_cancelation-policy---sb","cancelationPolicy":"Cart_cancelation-policy---sb","divider":"Cart_divider---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/styles.less
// module id = 1660
// module chunks = 0